import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import { anyActiveRequests } from 'selectors/appStatusSelectors'

import armguy from 'static/images/wackyArmGuyTransparent.gif'

import './index.scss'

export function AppStatus(props) {
  let { className, activeRequests } = props

  return (
    <div
      className={c('app-status-wrapper', className, {
        show: activeRequests,
      })}
    >
      <div className={c('app-status')}>
        <span>
          <img src={armguy} alt="We're working on it!" />
        </span>
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    activeRequests: anyActiveRequests(state),
  }
}

export default connect(mapStateToProps)(AppStatus)
